// ABOUTME: Tab with dropdown subroutes for the desktop navigation bar
// ABOUTME: Renders a tab button with a chevron that opens a MenuDropdown when clicked
import {
	clx,
	icon,
	Icon,
	MenuDropdown,
	Tab,
	type MenuItemConfig,
} from "@hm/fundamental"
import React, { useCallback } from "react"

import { DROPDOWN_CLASSES } from "../types"

export interface DropdownTabProps {
	label: string
	active?: boolean
	menuItems: MenuItemConfig[]
	isOpen: boolean
	onToggle: () => void
	dropdownRef: (el: HTMLDivElement | null) => void
	onClose: () => void
}

export const DropdownTab: React.FC<DropdownTabProps> = ({
	label,
	active,
	menuItems,
	isOpen,
	onToggle,
	dropdownRef,
	onClose,
}) => {
	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent) => {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault()
				onToggle()
			} else if (e.key === "Escape" && isOpen) {
				e.preventDefault()
				onClose()
			}
		},
		[onToggle, onClose, isOpen],
	)

	return (
		<div className="relative flex-shrink-0" data-tab-item>
			<button
				type="button"
				className={clx(
					"cursor-pointer flex items-center gap-2 bg-transparent border-none p-0",
					active
						? "text-primary hover:text-primary_hover active:text-primary_selected"
						: "text-foreground hover:text-foreground_faded_selected active:text-foreground_hover",
					"after:h-2px after:w-full after:block after:rounded-sm",
					active
						? "after:bg-primary hover:after:bg-primary_hover active:after:bg-primary_selected"
						: "",
					"whitespace-nowrap flex-shrink-0",
				)}
				onClick={onToggle}
				onKeyDown={handleKeyDown}
				aria-expanded={isOpen}
				aria-haspopup="true"
				data-cy={`tab-${label}`}
			>
				<Tab
					label={label}
					onSelect={() => {}}
					isActive={active}
					className="whitespace-nowrap flex-shrink-0 pointer-events-none"
				/>
				<Icon
					path={icon.mdiChevronDown}
					className={clx(
						"transition-transform",
						isOpen && "rotate-180",
					)}
				/>
			</button>

			{isOpen && (
				<div className="absolute top-full left-0 mt-2 z-[10000]">
					<div ref={dropdownRef} className={DROPDOWN_CLASSES}>
						<MenuDropdown items={menuItems} closeMenu={onClose} />
					</div>
				</div>
			)}
		</div>
	)
}
